
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting CHECK_REPORT_ERROR types, which identify a class of issues related to the creation of a Check Report.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Check Report errors' subtitle='Guide to troubleshooting Check Report errors' mdxType="Header" />
    <h4 {...{
      "id": "consumer_report_expired"
    }}><strong parentName="h4">{`CONSUMER_REPORT_EXPIRED`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='CONSUMER_REPORT_EXPIRED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The Check Report has expired as 24 hours have passed since its creation, so it is no longer retrievable.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='CONSUMER_REPORT_EXPIRED' mdxType="Checkbox">
        <p>{`Create a new report for the user by calling `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "consumer_report_not_found"
    }}><strong parentName="h4">{`CONSUMER_REPORT_NOT_FOUND`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='CONSUMER_REPORT_NOT_FOUND' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`No report has been created for this user.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='CONSUMER_REPORT_NOT_FOUND_2' mdxType="Checkbox">
        <p>{`If you have not already generated a report for this user, generate one by calling `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{`.`}</p>
      </Checkbox>
      <Checkbox checklistId='CONSUMER_REPORT_NOT_FOUND_3' mdxType="Checkbox">
        <p>{`Make sure you have received the `}<a parentName="p" {...{
            "href": "/docs/api/products/check-legacy/#user_check_report_ready"
          }}><inlineCode parentName="a">{`USER_CHECK_REPORT_READY`}</inlineCode></a>{` webhook before attempting to retrieve the report. If you receive the `}<a parentName="p" {...{
            "href": "https://plaid.com/docs/api/products/check-legacy/#user_check_report_failed"
          }}><inlineCode parentName="a">{`USER_CHECK_REPORT_FAILED`}</inlineCode></a>{` webhook instead, check the `}<inlineCode parentName="p">{`error`}</inlineCode>{` object for details.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "user_on_identity_theft_or_fraud_block"
    }}><strong parentName="h4">{`USER_ON_IDENTITY_THEFT_OR_FRAUD_BLOCK`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='USER_ON_IDENTITY_THEFT_OR_FRAUD_BLOCK' subtitle='The user has reported fraud or identity theft to Plaid Check.' server mdxType="ErrorReference">
      <p><inlineCode parentName="p">{`/cra/report/get`}</inlineCode>{` returns this error with an `}<inlineCode parentName="p">{`error_type`}</inlineCode>{` of `}<inlineCode parentName="p">{`CRA_REPORT_ERROR`}</inlineCode>{`. `}<inlineCode parentName="p">{`/link/token/create`}</inlineCode>{` and the legacy `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{` endpoint return it with an `}<inlineCode parentName="p">{`error_type`}</inlineCode>{` of `}<inlineCode parentName="p">{`CONSUMER_REPORT_ERROR`}</inlineCode>{`.`}</p>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='USER_ON_IDENTITY_THEFT_OR_FRAUD_BLOCK' mdxType="Checkbox">
        <p>{`If the end user believes the block was placed in error or no longer applies, they can request its removal through the `}<a parentName="p" {...{
            "href": "https://plaid.com/check/consumer-service-center/"
          }}>{`Plaid Check Consumer Help Center`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "user_on_security_freeze"
    }}><strong parentName="h4">{`USER_ON_SECURITY_FREEZE`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='USER_ON_SECURITY_FREEZE' subtitle='The user has placed a security freeze with Plaid Check.' server mdxType="ErrorReference">
      <p><inlineCode parentName="p">{`/cra/report/get`}</inlineCode>{` returns this error with an `}<inlineCode parentName="p">{`error_type`}</inlineCode>{` of `}<inlineCode parentName="p">{`CRA_REPORT_ERROR`}</inlineCode>{`. `}<inlineCode parentName="p">{`/link/token/create`}</inlineCode>{` and the legacy `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{` endpoint return it with an `}<inlineCode parentName="p">{`error_type`}</inlineCode>{` of `}<inlineCode parentName="p">{`CONSUMER_REPORT_ERROR`}</inlineCode>{`.`}</p>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='USER_ON_SECURITY_FREEZE' mdxType="Checkbox">
        <p>{`If the end user no longer wants the freeze in place, they can lift it through the `}<a parentName="p" {...{
            "href": "https://plaid.com/check/consumer-service-center/"
          }}>{`Plaid Check Consumer Help Center`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "data_unavailable"
    }}><strong parentName="h4">{`DATA_UNAVAILABLE`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='CHECK_REPORT_DATA_UNAVAILABLE' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Plaid Check failed to retrieve data from the user's financial institutions to generate Check Report product data.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='DATA_UNAVAILABLE' mdxType="Checkbox">
        <p>{`Check the `}<inlineCode parentName="p">{`causes`}</inlineCode>{` field for a detailed breakdown of errors, then follow the troubleshooting steps for any errors found.`}</p>
      </Checkbox>
      <Checkbox checklistId='DATA_UNAVAILABLE_2' mdxType="Checkbox">
        <p>{`If the `}<inlineCode parentName="p">{`causes`}</inlineCode>{` field is not present, use `}<inlineCode parentName="p">{`/user/items/get`}</inlineCode>{` to query the Items in the Check Report for errors, then follow the troubleshooting steps for any errors found.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "product_not_ready"
    }}><strong parentName="h4">{`PRODUCT_NOT_READY`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='PRODUCT_NOT_READY' subtitle='' server mdxType="ErrorReference">
      <Callout mdxType="Callout">
        <p>{`Note that this error should not be confused with the `}<a parentName="p" {...{
            "href": "/docs/errors/item/#product_not_ready"
          }}><inlineCode parentName="a">{`PRODUCT_NOT_READY`}</inlineCode></a>{` error of type `}<inlineCode parentName="p">{`ITEM_ERROR`}</inlineCode>{`, which has different causes.`}</p>
      </Callout>
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`/cra/check_report/.../get`}</inlineCode>{` was called before report generation completed.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-5"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='PRODUCT_NOT_READY' mdxType="Checkbox">
        <p>{`Listen for the `}<inlineCode parentName="p">{`USER_CHECK_REPORT_READY`}</inlineCode>{` or `}<inlineCode parentName="p">{`USER_CHECK_REPORT_FAILED`}</inlineCode>{` webhooks (legacy integrations created before December 10, 2025 also receive `}<inlineCode parentName="p">{`CHECK_REPORT_READY`}</inlineCode>{` / `}<inlineCode parentName="p">{`CHECK_REPORT_FAILED`}</inlineCode>{`) and wait to call `}<inlineCode parentName="p">{`/cra/check_report/.../get`}</inlineCode>{` until that webhook has been fired.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "institution_transaction_history_not_supported"
    }}><strong parentName="h4">{`INSTITUTION_TRANSACTION_HISTORY_NOT_SUPPORTED`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='INSTITUTION_TRANSACTION_HISTORY_NOT_SUPPORTED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The user's financial institution does not support the length of transaction history you require`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-6"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INSTITUTION_TRANSACTION_HISTORY_NOT_SUPPORTED' mdxType="Checkbox">
        <p>{`Lower the `}<inlineCode parentName="p">{`days_required`}</inlineCode>{` to be compatible with the financial institution's limits.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "insufficient_transaction_data"
    }}><strong parentName="h4">{`INSUFFICIENT_TRANSACTION_DATA`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='INSUFFICIENT_TRANSACTION_DATA' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The user does not have sufficient transactions data to generate income insights, partner insights, or cashflow insights. The `}<inlineCode parentName="li">{`error_message`}</inlineCode>{` will provide more detail on what data is missing.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-7"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INSUFFICIENT_TRANSACTION_DATA' mdxType="Checkbox">
        <p>{`Have the user connect a different financial institution that will satisfy the transaction requirements.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "no_accounts"
    }}><strong parentName="h4">{`NO_ACCOUNTS`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='CHECK_REPORT_NO_ACCOUNTS' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-6"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The user does not have the correct accounts linked to generate income insights. The `}<inlineCode parentName="li">{`error_message`}</inlineCode>{` will provide more detail on what data is missing.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-8"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='CHECK_REPORT_NO_ACCOUNTS' mdxType="Checkbox">
        <p>{`Have the user connect a different financial institution that will satisfy the transaction requirements.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "income_insights_deleted"
    }}><strong parentName="h4">{`INCOME_INSIGHTS_DELETED`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='INCOME_INSIGHTS_DELETED' subtitle='The Income Insights report requested for the PDF has been deleted.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-7"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The Income Insights report requested for the Check Report has been deleted and can no longer be included in the generated PDF.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-9"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INCOME_INSIGHTS_DELETED' mdxType="Checkbox">
        <p>{`Create a new Check Report with Income Insights by calling `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{`, wait for the `}<a parentName="p" {...{
            "href": "/docs/api/products/check-legacy/#user_check_report_ready"
          }}><inlineCode parentName="a">{`USER_CHECK_REPORT_READY`}</inlineCode></a>{` webhook (or `}<a parentName="p" {...{
            "href": "/docs/api/products/check-legacy/#check_report_ready"
          }}><inlineCode parentName="a">{`CHECK_REPORT_READY`}</inlineCode></a>{` for legacy integrations) and then retrieve the PDF again.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "network_consent_required"
    }}><strong parentName="h4">{`NETWORK_CONSENT_REQUIRED`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='NETWORK_CONSENT_REQUIRED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-8"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The user did not provide consent in link to share Plaid network data.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-10"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='NETWORK_CONSENT_REQUIRED' mdxType="Checkbox">
        <p>{`Have the user go through link again with `}<inlineCode parentName="p">{`cra_network_insights`}</inlineCode>{` or `}<inlineCode parentName="p">{`cra_cashflow_insights`}</inlineCode>{` so they can give consent to share network data`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "data_quality_check_failed"
    }}><strong parentName="h4">{`DATA_QUALITY_CHECK_FAILED`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='CHECK_REPORT_DATA_QUALITY_CHECK_FAILED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-9"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The extracted data from the financial institution showed signs of poor data quality, preventing the generation of an accurate report.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-11"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='DATA_QUALITY_CHECK_FAILED' mdxType="Checkbox">
        <p>{`Try creating the Check Report again 1-2 days later.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "product_not_requested"
    }}><strong parentName="h4">{`PRODUCT_NOT_REQUESTED`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='PRODUCT_NOT_REQUESTED' subtitle='The product was not requested when the Check Report was created.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-10"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`/cra/check_report/*/get`}</inlineCode>{` was called for a product that was not included in the `}<inlineCode parentName="li">{`products`}</inlineCode>{` array when the report was created via `}<inlineCode parentName="li">{`/link/token/create`}</inlineCode>{` or `}<inlineCode parentName="li">{`/cra/check_report/create`}</inlineCode>{`.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-12"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='PRODUCT_NOT_REQUESTED' mdxType="Checkbox">
        <p>{`Create a new report with `}<inlineCode parentName="p">{`/link/token/create`}</inlineCode>{` or `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{`, listing every Plaid Check product you intend to retrieve in the `}<inlineCode parentName="p">{`products`}</inlineCode>{` array, then retrieve the product from that report.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "no_matching_user"
    }}><strong parentName="h4">{`NO_MATCHING_USER`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_ERROR' error='NO_MATCHING_USER' subtitle='Plaid Check could not find a consumer profile for the user.' server mdxType="ErrorReference">
      <p>{`Returned by `}<inlineCode parentName="p">{`/cra/report/get`}</inlineCode>{`.`}</p>
      <h5 {...{
        "id": "common-causes-11"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`identity`}</inlineCode>{` on the user does not match a Plaid Check consumer profile.`}</li>
        <li parentName="ul">{`The user has no identity information.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-13"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='NO_MATCHING_USER' mdxType="Checkbox">
        <p>{`Make sure the user's `}<inlineCode parentName="p">{`identity`}</inlineCode>{` is complete and accurate. If it isn't, correct it with `}<inlineCode parentName="p">{`/user/update`}</inlineCode>{`.`}</p>
      </Checkbox>
      <Checkbox checklistId='NO_MATCHING_USER_2' mdxType="Checkbox">
        <p>{`Send the user through a Plaid Check Link flow, then call `}<inlineCode parentName="p">{`/cra/report/get`}</inlineCode>{` again.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "consumer_report_expired",
        level: 4,
        title: "CONSUMER_REPORT_EXPIRED",
      },
{
        id: "consumer_report_not_found",
        level: 4,
        title: "CONSUMER_REPORT_NOT_FOUND",
      },
{
        id: "user_on_identity_theft_or_fraud_block",
        level: 4,
        title: "USER_ON_IDENTITY_THEFT_OR_FRAUD_BLOCK",
      },
{
        id: "user_on_security_freeze",
        level: 4,
        title: "USER_ON_SECURITY_FREEZE",
      },
{
        id: "data_unavailable",
        level: 4,
        title: "DATA_UNAVAILABLE",
      },
{
        id: "product_not_ready",
        level: 4,
        title: "PRODUCT_NOT_READY",
      },
{
        id: "institution_transaction_history_not_supported",
        level: 4,
        title: "INSTITUTION_TRANSACTION_HISTORY_NOT_SUPPORTED",
      },
{
        id: "insufficient_transaction_data",
        level: 4,
        title: "INSUFFICIENT_TRANSACTION_DATA",
      },
{
        id: "no_accounts",
        level: 4,
        title: "NO_ACCOUNTS",
      },
{
        id: "income_insights_deleted",
        level: 4,
        title: "INCOME_INSIGHTS_DELETED",
      },
{
        id: "network_consent_required",
        level: 4,
        title: "NETWORK_CONSENT_REQUIRED",
      },
{
        id: "data_quality_check_failed",
        level: 4,
        title: "DATA_QUALITY_CHECK_FAILED",
      },
{
        id: "product_not_requested",
        level: 4,
        title: "PRODUCT_NOT_REQUESTED",
      },
{
        id: "no_matching_user",
        level: 4,
        title: "NO_MATCHING_USER",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
